import UrlsConfig from "../../../../config/urls.conf";
import axios from 'axios';

const createSseEventSource = (context, payload)  => {
    let url = `${UrlsConfig.govUrl}/api/sse/subscribe/${payload.cmpnId}/${payload.menuName}`;
    let eventSource = new EventSource(url);

    eventSource.addEventListener(payload.menuName,event => {
        context.commit('setLastEventId', event.lastEventId);
        context.commit('setSseResponseData', event.data+'_'+event.timeStamp);
    })
    eventSource.onerror = (event) => {
        if (event.target.readyState === EventSource.CLOSED) {
            context.commit('setIsSseEventSourceClosed', true);
            console.error('SSE CREATE ERROR : ' + '(' + event + ')');
        }

    }
    context.commit('setSseEventSource', eventSource);
}

const completeSseEventSource = (context) => {
    if (!context.state.sseEventSource) {
        return;
    }

    context.state.sseEventSource.close();
    context.commit('setSseEventSource', null);

    let url = `/api/sse/unsubscribe/${context.state.lastEventId}`;
    try {
        axios.delete(url);
    } catch (err) {
        console.error("SSE COMPLETE ERROR : ", err);
    } finally {
        context.commit('setLastEventId', '');
    }
}

export default {
    createSseEventSource,
    completeSseEventSource
};



// WEBPACK FOOTER //
// ./src/store/modules/sse/actions.js